export default __webpack_public_path__ + "static/media/phone.0ac2e487.svg";